/**
 * @param eventType Type of event to track
 * @param productsToTrack List of products to track
 * @param productIndex  Index position of first product to track
 * @param carouselTitle Carousel title text
 */
const trackProductEvent = (eventType, productsToTrack, productIndex, carouselTitle) => {
    var _a;
    const finalData = {
        imp_atelier: [],
        imp_brand: [],
        imp_category: [],
        imp_id: [],
        imp_name: [],
        imp_origin_system: [],
        imp_origin: [],
        imp_original_price: [],
        imp_position: [],
        imp_price: [],
        imp_variant: [],
        list_action: eventType,
        list_filter: '',
        list_name: carouselTitle || '',
        list_sorting: '',
    };
    productsToTrack.forEach((product, offset) => {
        const { articleCode, category, title: name, redPriceValue, regularPriceValue, atelierName, variantColor, } = product;
        finalData.imp_atelier.push(atelierName || '');
        finalData.imp_brand.push(process.env.BRAND_PREFIX || '');
        finalData.imp_category.push(category || '');
        finalData.imp_id.push(`${articleCode || ''}`);
        finalData.imp_name.push((name === null || name === void 0 ? void 0 : name.toUpperCase()) || '');
        finalData.imp_origin_system.push('e-sales');
        finalData.imp_origin.push('');
        finalData.imp_original_price.push(regularPriceValue || '');
        finalData.imp_position.push(productIndex + offset + 1);
        finalData.imp_price.push(redPriceValue || regularPriceValue || '');
        finalData.imp_variant.push(variantColor || '');
    });
    (_a = window.TealiumUtils) === null || _a === void 0 ? void 0 : _a.utagTrackEventLink('', '', '', finalData);
};
export default trackProductEvent;
//# sourceMappingURL=trackProductEvent.js.map